import PropTypes from 'prop-types'
import React from 'react'

const Header = props => (
  <header id="header" style={props.timeout ? { display: 'none' } : {}}>
    <div className="logo">
      <span className="icon fa-coffee"></span>
    </div>
    <div className="content">
      <div className="inner">
        <h1>Modal Workplace, LLC</h1>
        <p>
        Swag letterpress kickstarter ennui migas locavore biodiesel godard <br/>squid scenester glossier sriracha la croix chicharrones direct trade. 
        </p>
      </div>
    </div>
    <nav>
      <ul>
        {/* <li>
          <button
            style={{
              marginLeft: '0px',
              marginRight: '1px'
            }}
            onClick={() => {
              props.onOpenArticle('intro')
            }}
          >
            Learn More
          </button>
        </li> */}
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('contact')
            }}
          >
            More Info
          </button>
        </li>
        {/* <li>
          <button
            onClick={() => {
              props.onOpenArticle('about')
            }}
          >
            About
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('contact')
            }}
          >
            Contact
          </button>
        </li> */}
      </ul>
    </nav>
  </header>
)

Header.propTypes = {
  onOpenArticle: PropTypes.func,
  timeout: PropTypes.bool,
}

export default Header
